import React from 'react'
import { IonContent, IonList, IonPage } from '@ionic/react'
import Header from '../../components/Header'
import './index.css'
import { useHistory } from 'react-router'
import { GroupWelcomePage } from '../../conf/routePath'

const ManageGroup: React.FC<{}> = () => {
    const history = useHistory()
    return (
        <IonPage>
            <IonContent className='baseContent'>
                <Header title='群管理' />

                <IonList>
                    <div
                        className='manageItem'
                        onClick={() => history.push(GroupWelcomePage)}
                    >
                        <p className='manageTitle'>新人入群管欢迎语</p>
                        <p>当有新人入群,机器人会发送欢迎语</p>
                    </div>
                </IonList>
            </IonContent>
        </IonPage>
    )
}

export default ManageGroup
